import { postGrowthEngineAnalytics } from './growthEngineApi'
import { OLLIE_PLATFORM } from './ollieFindingsApi'

export const OLLIE_SUGGESTION_SELECTED = 'ollie_suggestion_selected'
export const OLLIE_SUGGESTION_SENT = 'ollie_suggestion_sent'
export const OLLIE_SUGGESTION_SUCCEEDED = 'ollie_suggestion_succeeded'

const KNOWN_PROMPT_IDS = Object.freeze({
  'what needs my attention today': 'today',
  'show my outstanding deliveries': 'outstanding_deliveries',
  'show my outstanding invoice issues': 'outstanding_invoices',
  'why is this invoice outstanding': 'why_invoice_outstanding',
  'what food safety checks are overdue': 'fs_overdue',
  'what food safety checks are due today': 'fs_due_today',
  'help me find products to order': 'order',
  'help me find mozzarella': 'find_mozzarella',
  'how did we do this week': 'week',
  "what's still owed to me": 'owed',
  'which prices went up': 'prices',
})

const post = (venueId, body) => {
  if (!venueId || !body?.eventName) return Promise.resolve(null)
  return postGrowthEngineAnalytics(venueId, {
    platform: body.platform || OLLIE_PLATFORM,
    ...body,
  }).catch(() => null)
}

/** Stable id for curated chips (Home / first-use / starters). */
export function ollieSuggestionPromptId(text = '', promptId = null) {
  if (promptId) return String(promptId)
  const normalised = String(text || '')
    .trim()
    .replace(/[.!?]+$/, '')
    .toLowerCase()
  if (!normalised) return null
  return KNOWN_PROMPT_IDS[normalised] || null
}

export function trackOllieSuggestionSelected({
  venueId,
  promptId = null,
  question = null,
  surface = 'starter',
  page = null,
  platform = OLLIE_PLATFORM,
} = {}) {
  const id = ollieSuggestionPromptId(question, promptId)
  return post(venueId, {
    eventName: OLLIE_SUGGESTION_SELECTED,
    platform,
    metadata: {
      surface: String(surface),
      source: 'ollie',
      ...(id ? { promptId: id } : {}),
      ...(question ? { question: String(question).slice(0, 200) } : {}),
      ...(page ? { page: String(page) } : {}),
    },
  })
}

export function trackOllieSuggestionSent({
  venueId,
  promptId = null,
  question = null,
  edited = false,
  surface = 'starter',
  platform = OLLIE_PLATFORM,
} = {}) {
  const id = ollieSuggestionPromptId(question, promptId)
  if (!id && !question) return Promise.resolve(null)
  return post(venueId, {
    eventName: OLLIE_SUGGESTION_SENT,
    platform,
    metadata: {
      surface: String(surface),
      source: 'ollie',
      edited: Boolean(edited),
      ...(id ? { promptId: id } : {}),
      ...(question ? { question: String(question).slice(0, 200) } : {}),
    },
  })
}

/** Helpful feedback or a clean answer after a suggestion-backed send. */
export function trackOllieSuggestionSucceeded({
  venueId,
  promptId = null,
  question = null,
  surface = 'starter',
  reason = 'helpful',
  platform = OLLIE_PLATFORM,
} = {}) {
  const id = ollieSuggestionPromptId(question, promptId)
  if (!id && !question) return Promise.resolve(null)
  return post(venueId, {
    eventName: OLLIE_SUGGESTION_SUCCEEDED,
    platform,
    metadata: {
      surface: String(surface),
      source: 'ollie',
      reason: String(reason || 'helpful'),
      ...(id ? { promptId: id } : {}),
      ...(question ? { question: String(question).slice(0, 200) } : {}),
    },
  })
}
